import req from "../http";

const jobSetting = {
  // 取得 排程(分頁)
  getJobSettingPaging(params) {
    return req("get", "/JobViewer/getJobSetting/paging", params);
  },

  // 取得 所有該排程紀錄
  getJobRecord(params) {
    return req("get", "/JobViewer/getJobRecord", params);
  },

  // 手動執行 排程
  manualExecuteJob(params) {
    return req("post", "/JobViewer/manualExecuteJob", params);
  },

  // 設定 排程時間
  settingJobSettingTime(params) {
    return req("put", "/JobViewer/updateJobSettingTimeSetting", params);
  },

  // 啟用、停用 排程
  updateJobSettingEnabled(params) {
    return req("put", "/JobViewer/updateJobSettingEnabled", params);
  },
};

export default jobSetting;